import { Box} from "@chakra-ui/react";
import ProductContainer from "views/Products/ProductContainer";

const Products = ({}) => {
  return (
    < >
   <ProductContainer/>
    </>
  );
};

export default Products;
